// tslint:disable
/**
 * Document generator api
 * Generate documents from templates
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as globalImportUrl from 'url';
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';

import { Generate } from '../models';
import { GenerateResult } from '../models';
import { Variable } from '../models';
/**
 * EducationProtocolApi - axios parameter creator
 * @export
 */
export const EducationProtocolApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {Generate} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateEducationProtocol(id: string, body: Generate, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling generateEducationProtocol.');
            }
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling generateEducationProtocol.');
            }
            const localVarPath = `/document-generator/education-protocol/generate/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<string>} ids 
         * @param {Generate} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateEducationProtocolMultiply(ids: Array<string>, body: Generate, options: any = {}): RequestArgs {
            // verify required parameter 'ids' is not null or undefined
            if (ids === null || ids === undefined) {
                throw new RequiredError('ids','Required parameter ids was null or undefined when calling generateEducationProtocolMultiply.');
            }
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling generateEducationProtocolMultiply.');
            }
            const localVarPath = `/document-generator/education-protocol/generate`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (ids) {
                localVarQueryParameter['ids'] = ids.join(COLLECTION_FORMATS.csv);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        infoEducationProtocol(options: any = {}): RequestArgs {
            const localVarPath = `/document-generator/education-protocol/info`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EducationProtocolApi - functional programming interface
 * @export
 */
export const EducationProtocolApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {Generate} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateEducationProtocol(id: string, body: Generate, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<GenerateResult> {
            const localVarAxiosArgs = EducationProtocolApiAxiosParamCreator(configuration).generateEducationProtocol(id, body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {Array<string>} ids 
         * @param {Generate} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateEducationProtocolMultiply(ids: Array<string>, body: Generate, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<GenerateResult> {
            const localVarAxiosArgs = EducationProtocolApiAxiosParamCreator(configuration).generateEducationProtocolMultiply(ids, body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        infoEducationProtocol(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Variable>> {
            const localVarAxiosArgs = EducationProtocolApiAxiosParamCreator(configuration).infoEducationProtocol(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * EducationProtocolApi - factory interface
 * @export
 */
export const EducationProtocolApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {Generate} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateEducationProtocol(id: string, body: Generate, options?: any) {
            return EducationProtocolApiFp(configuration).generateEducationProtocol(id, body, options)(axios, basePath);
        },
        /**
         * 
         * @param {Array<string>} ids 
         * @param {Generate} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateEducationProtocolMultiply(ids: Array<string>, body: Generate, options?: any) {
            return EducationProtocolApiFp(configuration).generateEducationProtocolMultiply(ids, body, options)(axios, basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        infoEducationProtocol(options?: any) {
            return EducationProtocolApiFp(configuration).infoEducationProtocol(options)(axios, basePath);
        },
    };
};

/**
 * EducationProtocolApi - object-oriented interface
 * @export
 * @class EducationProtocolApi
 * @extends {BaseAPI}
 */
export class EducationProtocolApi extends BaseAPI {
    /**
     * 
     * @param {string} id 
     * @param {Generate} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EducationProtocolApi
     */
    public generateEducationProtocol(id: string, body: Generate, options?: any) {
        return EducationProtocolApiFp(this.configuration).generateEducationProtocol(id, body, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {Array<string>} ids 
     * @param {Generate} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EducationProtocolApi
     */
    public generateEducationProtocolMultiply(ids: Array<string>, body: Generate, options?: any) {
        return EducationProtocolApiFp(this.configuration).generateEducationProtocolMultiply(ids, body, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EducationProtocolApi
     */
    public infoEducationProtocol(options?: any) {
        return EducationProtocolApiFp(this.configuration).infoEducationProtocol(options)(this.axios, this.basePath);
    }

}
